import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ITdDynamicElementConfig, TdDynamicElement, TdDynamicType } from '@covalent/dynamic-forms';
import { TdFileService, IUploadOptions, ITdDataTableColumn, ITdDataTableSortChangeEvent, TdDataTableSortingOrder, IPageChangeEvent, TdDataTableService } from '@covalent/core';
import { TdLoadingService } from '@covalent/core';
import { TdDialogService } from '@covalent/core';
import { Location } from '@angular/common';

import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/do';
import { Observable } from 'rxjs/Observable';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { MdDialogRef, MdDialog } from '@angular/material';

import { Fabrictype } from '../fabrictype';
import { FabrictypeService } from '../fabrictype.service';
import { SettingsService } from 'app/shared/services/settings.service';
import { Utils } from 'app/shared/utils';
import { CollectionsListComponent } from '../../collections-list/collections-list.component';


@Component({
  selector: 'app-fabrictype',
  templateUrl: './fabrictype.component.html',
  styleUrls: ['./fabrictype.component.scss']
})
export class FabrictypeComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];

  sortBy: string = 'name';
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;

  fromRow: number = 1;
  currentPage: number = 1;

  allUnits = [
    { name: 'Meters, Yards', value: 'LENGTH' },
    { name: 'Meters², SqFt', value: 'AREA' },
    { name: 'None', value: 'NONE' }
  ];

  data: Fabrictype;
  currentFabrictype: Fabrictype;
  originalFabrictype: Fabrictype;

  subscription: Subscription = new Subscription();
  title: string;
  isEditMode: boolean;


  constructor(
    private _dataTableService: TdDataTableService,
    private _dialogService: TdDialogService,
    private _loadingService: TdLoadingService,
    private _fabrictypeService: FabrictypeService,
    public _authService: AuthenticationService,
    private _dialog: MdDialog,
    private _settingsService: SettingsService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location) { }

  ngOnInit(): void {
    this._loadingService.register('loading');

    this.route.paramMap.switchMap((params: ParamMap) => this.mode(params.get('id'))).subscribe(
      (currentFabrictype: Fabrictype) => {
        this.currentFabrictype = currentFabrictype;

        // Load up the reference data
        this.originalFabrictype = Object.assign({}, this.currentFabrictype);

        this._loadingService.resolve('loading');
      });
  }

  createFabricType() {
    this._loadingService.register('loading');

    this._fabrictypeService.createFabricType(this.currentFabrictype).subscribe(
      (response) => {
        if (response['status'] == 'SUCCESS') {
          this.currentFabrictype.id = response['id'];

          this._loadingService.resolve('loading');

          this._dialogService.openAlert({
            message: 'Fabric type ' + this.currentFabrictype.name + ' created successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {
            this.router.navigate(['/purchasing', 'fabrictypes']);
          });

        } else {
          this._loadingService.resolve('loading');

          this._dialogService.openAlert({
            message: 'Could not create fabric type ' + this.currentFabrictype.name + ': ' + response.error.sqlMessage,
            title: 'Failed!',
          });
        }


      }
    );
  }

  saveFabricType() {
    this._loadingService.register('loading');

    this._fabrictypeService.updateFabricType(this.currentFabrictype.id, this.currentFabrictype).subscribe(
      (response) => {
        if (response['status'] == 'SUCCESS') {
          this._loadingService.resolve('loading');

          this._dialogService.openAlert({
            message: 'Fabric type ' + this.currentFabrictype.name + ' updated successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {
            this.router.navigate(['/purchasing', 'fabrictypes']);
          });
        } else {
          this._loadingService.resolve('loading');

          this._dialogService.openAlert({
            message: 'Could not update fabric type ' + this.currentFabrictype.name + ': ' + response.error.sqlMessage,
            title: 'Failed!',
          });
        }

      }
    );
  }

  goBack(): void {
    this.location.back();
  }

  changed(): boolean {
    for (let prop in this.currentFabrictype) {
      if (this.currentFabrictype[prop] != this.currentFabrictype[prop]) {
        return true;
      }
    }

    return false;
  }

  mode(id: string): Observable<Fabrictype> {
    if (id) {
      this.title = 'Edit Fabrictype';
      this.isEditMode = true;
      return this._fabrictypeService.getOneFabricType(id);
    }

    this.title = 'Create Fabrictype';
    this.isEditMode = false;
    return Observable.of(new Fabrictype());
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/purchasing/fabrictypes/fabrictype/fabrictype.component.ts